import React from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'
import Tooltip from 'components/Tooltip'

import { color } from 'styles/colors'

type Props = {
  severity: string
  count: number | null
  className?: string
  useTooltip?: boolean
}

const AlertIconWithCount = ({ severity, count, className, useTooltip = true } : Props) => (
  <div className={className} data-testid={`alert-${severity}`}>
    {(() => {
      if ((count ?? 0) > 0 && useTooltip) {
        return (
          <Tooltip title={`Total number of ${severity} alerts.`} >
            <S.Container readOnly>
              <S.Img src={`/img/${severity.replace('-', '_')}_alert.svg`} alt={`${severity.replace('-', ' ')} alert`} />
              <S.Count severity={severity}>
                {count}
              </S.Count>
            </S.Container>
          </Tooltip>
        )
      } else if ((count ?? 0) > 0 && !useTooltip) {
        return (
          <S.Container readOnly>
            <S.Img src={`/img/${severity.replace('-', '_')}_alert.svg`} alt={`${severity.replace('-', ' ')} alert`} />
            <S.Count severity={severity}>
              {count}
            </S.Count>
          </S.Container>
        )
      }
    })()}
  </div>
)

export default AlertIconWithCount

const S = {

  Count: styled.span.withConfig({
    shouldForwardProp: (prop) => !['severity'].includes(prop)
  })<{ severity: string }>`
    margin-left: 4px;
    margin-right: 5px;
    ${({ severity }) => `
    color: ${color(severity.replace('-s', 'S') + 'Alert')};
  `}
  `,
  Img: styled.img`
    width: 24px;
    height: 24px;
  `,
  Container: styled(KeyboardAccessible)`
    display: flex;
    align-items: center;
    margin-left: 5px;
    padding-left: 5px;
  `
}
